import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Profile = () => {
  const [userDetails, setUserDetails] = useState({});

  useEffect(() => {
    setUserDetails(JSON.parse(localStorage.getItem('loggedInUser')));
  }, []);

  return (
    <section className="max-w-[1200px] flex flex-col mx-auto h-full">
      <header className="w-full pt-4 md:pt-16 text-center">
        <h1 className="font-bold text-3xl md:text-4xl">
          {userDetails.fullName}
        </h1>
        <p className="pt-2 text-lg md:pt-6 md:text-xl">
          {userDetails.profession}
        </p>
      </header>
      <main className="w-full mx-0 flex flex-col md:flex-row md:mt-[16vh]">
        <div className="mx-auto px-0 py-8 md:text-left md:w-1/3 md:p-8">
          <h3 className="text-xl pb-2 md:text-2xl md:pb-8">About me</h3>
          <p className="leading-6 md:leading-8">{userDetails.aboutMe}</p>
        </div>
        <div className="flex justify-center md:w-1/3 md:px-0 md:py-8 lg:p-8 md:items-start lg:items-center">
          <img
            src={userDetails ? `${userDetails.profilePicture}` : ''}
            alt="Profile"
            className="object-cover rounded-full w-[225px] h-[225px] lg:w-[250px] lg:h-[250px] "
          />
        </div>
        <div className="text-center md:text-left mx-auto px-0 py-8 md:w-1/3 md:p-8">
          <h3 className="text-xl pb-2 md:text-2xl md:pb-8">Details</h3>
          <div className="flex flex-col items-baseline md:items-start">
            <div className="pb-2 flex items-center md:pb-0 md:block ">
              <h6 className="font-bold leading-6 pr-2 md:pr-0 md:leading-8">
                Age:
              </h6>
              <p className="leading-5 md:leading-8">{userDetails.age} years</p>
            </div>
            <div className="pb-2 flex items-center md:pb-0 md:block ">
              <h6 className="font-bold leading-6 pr-2 md:pr-0 md:leading-8">
                Gender:
              </h6>
              <p className="leading-5 md:leading-8">{userDetails.gender}</p>
            </div>
            <div className="pb-2 flex items-center md:pb-0 md:block ">
              <h6 className="font-bold leading-6 pr-2 md:pr-0 md:leading-8">
                Location:
              </h6>
              <p className="leading-5 md:leading-8">{userDetails.location}</p>
            </div>
          </div>
        </div>
      </main>
      <footer className="mx-auto flex flex-col items- mb-0 pb-[64px] md:pb-0 md:pl-0 md:flex-row md:mt-auto md:mx-0 md:mb-11">
        <div className="flex px-0 md:w-1/3 md:px-8">
          <div className="flex my-auto">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 96 960 960"
              className="w-8 h-8 mr-1"
            >
              <path d="M798 936q-129 0-251.5-57.5t-217-152q-94.5-94.5-152-217T120 258q0-18 12-30t30-12h162q14 0 25 9t13 23l26 140q2 14-.5 25.5T376 434l-97 98q42 72 105.5 135T524 776l94-94q9-9 23.5-13.5T670 666l138 28q14 3 23 13.5t9 24.5v162q0 18-12 30t-30 12ZM241 456l66-66-17-94h-89q5 41 14 81t26 79Zm519 398v-88l-94-19-67 67q39 17 79.5 27t81.5 13Zm-160-41ZM241 456Z" />
            </svg>
          </div>
          <div className="py-2 flex items-center md:py-0 md:block">
            <h6 className="pl-2 md:pl-0">Call:</h6>
            <p className="pl-2 md:pl-0">{userDetails.phoneNumber}</p>
          </div>
        </div>
        <div className="flex w-full px-0 md:w-1/3 md:px-8 md:justify-center">
          <div className="flex my-auto">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 96 960 960"
              className="w-8 h-8 mr-1"
            >
              <path d="M160 896q-33 0-56.5-23.5T80 816V336q0-33 23.5-56.5T160 256h640q33 0 56.5 23.5T880 336v480q0 33-23.5 56.5T800 896H160Zm640-480L501 603q-5 3-10.5 4.5T480 609q-5 0-10.5-1.5T459 603L160 416v400h640V416ZM480 536l320-200H160l320 200ZM160 416v10-59 1-32 32-.5V426v-10 400-400Z" />
            </svg>
          </div>
          <div className="flex items-center md:block">
            <h6 className="pl-2 md:pl-0">Email:</h6>
            <p className="pl-2 md:pl-0">{userDetails.email}</p>
          </div>
        </div>
        <div className="w-full h-[40px] px-0 flex items-center md:items-start md:h-full md:justify-center md:px-8 md:w-1/3 md:flex-col">
          <h6>Socials:</h6>
          <div className="pl-2 flex items-center gap-x-2 md:pl-0 md:w-full">
            <Link to={userDetails.facebook}>
              <svg
                fill="#000000"
                viewBox="0 0 1920 1920"
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
              >
                <path
                  d="m1416.013 791.915-30.91 225.617h-371.252v789.66H788.234v-789.66H449.808V791.915h338.426V585.137c0-286.871 176.207-472.329 449.09-472.329 116.87 0 189.744 6.205 231.822 11.845l-3.272 213.66-173.5.338c-4.737-.451-117.771-9.25-199.332 65.655-52.568 48.169-79.191 117.433-79.191 205.65v181.96h402.162Zm-247.276-304.018c44.446-41.401 113.71-36.889 118.787-36.663l289.467-.113 6.204-417.504-43.544-10.717C1511.675 16.02 1426.053 0 1237.324 0 901.268 0 675.425 235.206 675.425 585.137v93.97H337v451.234h338.425V1920h451.234v-789.66h356.7l61.932-451.233H1126.66v-69.152c0-54.937 14.214-96 42.078-122.058Z"
                  fillRule="evenodd"
                  stroke="#000000"
                  strokeWidth="36px"
                />
              </svg>
            </Link>
            <Link to={userDetails.instagram}>
              <svg
                viewBox="0 0 20 20"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
              >
                <g
                  id="Page-1"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="Dribbble-Light-Preview"
                    transform="translate(-340.000000, -7439.000000)"
                    fill="#000000"
                  >
                    <g id="icons" transform="translate(56.000000, 160.000000)">
                      <path
                        d="M289.869652,7279.12273 C288.241769,7279.19618 286.830805,7279.5942 285.691486,7280.72871 C284.548187,7281.86918 284.155147,7283.28558 284.081514,7284.89653 C284.035742,7285.90201 283.768077,7293.49818 284.544207,7295.49028 C285.067597,7296.83422 286.098457,7297.86749 287.454694,7298.39256 C288.087538,7298.63872 288.809936,7298.80547 289.869652,7298.85411 C298.730467,7299.25511 302.015089,7299.03674 303.400182,7295.49028 C303.645956,7294.859 303.815113,7294.1374 303.86188,7293.08031 C304.26686,7284.19677 303.796207,7282.27117 302.251908,7280.72871 C301.027016,7279.50685 299.5862,7278.67508 289.869652,7279.12273 M289.951245,7297.06748 C288.981083,7297.0238 288.454707,7296.86201 288.103459,7296.72603 C287.219865,7296.3826 286.556174,7295.72155 286.214876,7294.84312 C285.623823,7293.32944 285.819846,7286.14023 285.872583,7284.97693 C285.924325,7283.83745 286.155174,7282.79624 286.959165,7281.99226 C287.954203,7280.99968 289.239792,7280.51332 297.993144,7280.90837 C299.135448,7280.95998 300.179243,7281.19026 300.985224,7281.99226 C301.980262,7282.98483 302.473801,7284.28014 302.071806,7292.99991 C302.028024,7293.96767 301.865833,7294.49274 301.729513,7294.84312 C300.829003,7297.15085 298.757333,7297.47145 289.951245,7297.06748 M298.089663,7283.68956 C298.089663,7284.34665 298.623998,7284.88065 299.283709,7284.88065 C299.943419,7284.88065 300.47875,7284.34665 300.47875,7283.68956 C300.47875,7283.03248 299.943419,7282.49847 299.283709,7282.49847 C298.623998,7282.49847 298.089663,7283.03248 298.089663,7283.68956 M288.862673,7288.98792 C288.862673,7291.80286 291.150266,7294.08479 293.972194,7294.08479 C296.794123,7294.08479 299.081716,7291.80286 299.081716,7288.98792 C299.081716,7286.17298 296.794123,7283.89205 293.972194,7283.89205 C291.150266,7283.89205 288.862673,7286.17298 288.862673,7288.98792 M290.655732,7288.98792 C290.655732,7287.16159 292.140329,7285.67967 293.972194,7285.67967 C295.80406,7285.67967 297.288657,7287.16159 297.288657,7288.98792 C297.288657,7290.81525 295.80406,7292.29716 293.972194,7292.29716 C292.140329,7292.29716 290.655732,7290.81525 290.655732,7288.98792"
                        id="instagram-[#167]"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </Link>
            <Link to={userDetails.twitter}>
              <svg
                viewBox="0 -47 512.00004 512"
                className="w-6 h-6 ml-1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke="#000000"
                  strokeWidth="5px"
                  d="m512 55.964844c-32.207031 1.484375-31.503906 1.363281-35.144531 1.667968l19.074219-54.472656s-59.539063 21.902344-74.632813 25.820313c-39.640625-35.628907-98.5625-37.203125-140.6875-11.3125-34.496094 21.207031-53.011719 57.625-46.835937 100.191406-67.136719-9.316406-123.703126-41.140625-168.363282-94.789063l-14.125-16.964843-10.554687 19.382812c-13.339844 24.492188-17.769531 52.496094-12.476563 78.851563 2.171875 10.8125 5.863282 21.125 10.976563 30.78125l-12.117188-4.695313-1.4375 20.246094c-1.457031 20.566406 5.390625 44.574219 18.320313 64.214844 3.640625 5.53125 8.328125 11.605469 14.269531 17.597656l-6.261719-.960937 7.640625 23.199218c10.042969 30.480469 30.902344 54.0625 57.972657 67.171875-27.035157 11.472657-48.875 18.792969-84.773438 30.601563l-32.84375 10.796875 30.335938 16.585937c11.566406 6.324219 52.4375 27.445313 92.820312 33.78125 89.765625 14.078125 190.832031 2.613282 258.871094-58.664062 57.308594-51.613282 76.113281-125.03125 72.207031-201.433594-.589844-11.566406 2.578125-22.605469 8.921875-31.078125 12.707031-16.964844 48.765625-66.40625 48.84375-66.519531zm-72.832031 48.550781c-10.535157 14.066406-15.8125 32.03125-14.867188 50.578125 3.941407 77.066406-17.027343 136.832031-62.328125 177.628906-52.917968 47.660156-138.273437 66.367188-234.171875 51.324219-17.367187-2.722656-35.316406-8.820313-50.171875-14.910156 30.097656-10.355469 53.339844-19.585938 90.875-37.351563l52.398438-24.800781-57.851563-3.703125c-27.710937-1.773438-50.785156-15.203125-64.96875-37.007812 7.53125-.4375 14.792969-1.65625 22.023438-3.671876l55.175781-15.367187-55.636719-13.625c-27.035156-6.621094-42.445312-22.796875-50.613281-35.203125-5.363281-8.152344-8.867188-16.503906-10.96875-24.203125 5.578125 1.496094 12.082031 2.5625 22.570312 3.601563l51.496094 5.09375-40.800781-31.828126c-29.398437-22.929687-41.179687-57.378906-32.542969-90.496093 91.75 95.164062 199.476563 88.011719 210.320313 90.527343-2.386719-23.183593-2.449219-23.238281-3.074219-25.445312-13.886719-49.089844 16.546875-74.015625 30.273438-82.453125 28.671874-17.621094 74.183593-20.277344 105.707031 8.753906 6.808593 6.265625 16.015625 8.730469 24.632812 6.589844 7.734375-1.921875 14.082031-3.957031 20.296875-6.171875l-12.9375 36.945312 16.515625.011719c-3.117187 4.179688-6.855469 9.183594-11.351562 15.183594zm0 0"
                />
              </svg>
            </Link>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default Profile;
